import events from '@/utils/eventBus'

const draftMap = new Map<string, any>()

events.on('multiTab.closed', (targetKey: string) => {
  draftMap.delete(targetKey)
})

export const formDraft = {
  get(key: string) {
    return draftMap.get(key)
  },
  set(key: string, value: any) {
    draftMap.set(key, value)
  },
  remove(key: string) {
    draftMap.delete(key)
  },
  clear() {
    draftMap.clear()
  }
}
